import SubscriptionInactiveGate from "./SubscriptionInactiveGate";

interface SubscriptionSectionGateProps {
  section: string;
}

// Shown in place of a feature section (appointments, clients, follow-ups…)
// when the organization has no active subscription. Mirrors the messaging gate.
const SubscriptionSectionGate = ({ section }: SubscriptionSectionGateProps) => (
  <SubscriptionInactiveGate
    title="Subscription inactive"
    message={`Your organization does not have an active subscription, so ${section} is unavailable. Please contact the platform administrator to activate a plan.`}
  />
);

export default SubscriptionSectionGate;